// src/components/Layout/Secao.js
//
// Bloco de pagina. Existe para que nenhuma secao invente a propria margem.
//
// O que ele garante:
//   1. Todo bloco usa o MESMO trilho horizontal (Container xl = 1280,
//      normalizado no tema em App.js). Ninguem mais escolhe lg ou md na mao.
//   2. O respiro vertical vem de tres ritmos nomeados, nao de numeros soltos.
//      Todos sao degraus da escala base 8 declarada em App.js.
//   3. semTopo / semBase colapsam a costura entre dois blocos vizinhos que
//      compartilham o mesmo fundo - sem isso o respiro dobra.
//
// Uso:
//   <Secao fundo='branco' ritmo='padrao'>...</Secao>
//   <Secao><Leitura>texto corrido</Leitura></Secao>
//
import React from 'react';
import { Box, Container } from '@mui/material';

// xs = telefone, md = 900px pra cima. Valores em degraus de 8px:
// 3=24  5=40  9=72  12=96
const RITMOS = {
  apertado: { xs: 3, md: 5 },
  padrao:   { xs: 5, md: 9 },
  solto:    { xs: 9, md: 12 },
};

const FUNDOS = {
  padrao: 'background.default',
  branco: 'background.paper',
  nenhum: 'transparent',
};

const Secao = ({
  fundo = 'nenhum',
  ritmo = 'padrao',
  semTopo = false,
  semBase = false,
  children,
  sx,
  ...resto
}) => {
  const py = RITMOS[ritmo] || RITMOS.padrao;
  return (
    <Box
      component='section'
      sx={{
        bgcolor: FUNDOS[fundo] || FUNDOS.nenhum,
        pt: semTopo ? 0 : py,
        pb: semBase ? 0 : py,
        ...sx,
      }}
      {...resto}
    >
      <Container maxWidth='xl'>{children}</Container>
    </Box>
  );
};

// Largura de leitura dentro do trilho.
//
// ATENCAO: margin-right auto, margin-left NAO. Um bloco de texto estreito
// dentro de um trilho largo tem que ENCOSTAR na margem esquerda, junto com o
// titulo da secao e com todos os outros blocos da pagina. Centralizar cria um
// segundo alinhamento invisivel e a pagina passa a ter duas margens
// esquerdas concorrentes - foi o erro pego no FAQ.
export const Leitura = ({ largura = 768, children, sx, ...resto }) => (
  <Box sx={{ maxWidth: largura, marginRight: 'auto', ...sx }} {...resto}>
    {children}
  </Box>
);

export default Secao;
